/**
 * Options for auto scrolling
 */
export var AutoScrollStrategy;
(function (AutoScrollStrategy) {
    AutoScrollStrategy["NextAttribute"] = "nextAttribute";
    AutoScrollStrategy["NextIncompleteAttribute"] = "nextIncompleteAttribute";
})(AutoScrollStrategy || (AutoScrollStrategy = {}));
//# sourceMappingURL=AutoScrollStrategy.js.map